import React from 'react';
import { SettingCard, SettingCardProps } from '../SettingCard/SettingCard';
import { SettingCardContent } from '../SettingCard/SettingCardContent/SettingCardContent';
import { Dropdown, DropdownOption } from '../../Dropdown/Dropdown';
import './DropdownSetting.css';

interface DropdownSettingProps extends Omit<
	SettingCardProps,
	'content' | 'className' | 'showContentSeparator'
> {
	label: string;
	options: DropdownOption[];
	selectedValue: string;
	onChange: (value: string) => void;
}

export interface DropdownSettingValue {
	selectedOption: string;
	availableOptions: Array<{ value: string; label: string }>;
}

export const DropdownSetting: React.FC<DropdownSettingProps> = ({
	title,
	description,
	label,
	settingId,
	options,
	selectedValue,
	disabled = false,
	onChange,
	learnMoreUrl,
	learnMoreText,
}) => {
	return (
		<SettingCard
			title={title}
			description={description}
			settingId={settingId}
			disabled={disabled}
			learnMoreUrl={learnMoreUrl}
			learnMoreText={learnMoreText}
			content={
				<SettingCardContent className="dropdown">
					<Dropdown
						label={label}
						options={options}
						value={selectedValue}
						onChange={onChange}
						disabled={disabled}
					/>
				</SettingCardContent>
			}
		/>
	);
};
